import Promise from 'bluebird';
// eslint-disable-next-line
import { loadMap } from '@bingads-webui-campaign-legacy/dashboard-page/service/load-map';
import { withMergedI18n } from './i18n-utils';

function loadLegacyI18n({
  hasMultipleCultures = false,
}) {
  const loadLegacyI18nWebpack = hasMultipleCultures ? window.globalLegacyI18n.loadI18nWithMultipleCultures : window.globalLegacyI18n.loadI18n;

  return loadLegacyI18nWebpack();
}

function loadGoogleApi() {
  return new Promise((resolve) => {
    // eslint-disable-next-line no-undef
    __non_webpack_require__([
      'ext/google/gsi',
    ], () => {
      resolve();
    });
  });
}

export function loadPageWebpack({
  importFeature,
  importL10n,
  hasLegacyI18n = false,
  hasMultipleCultures = false,
  hasBingMap = false,
  hasGoogleApi = false,
}) {
  const nop = Promise.resolve();
  const FeaturePromise = Promise.all([
    importL10n(),
    hasLegacyI18n ? loadLegacyI18n({ hasMultipleCultures }) : nop,
    hasBingMap ? loadMap() : nop,
    hasGoogleApi ? loadGoogleApi() : nop,
  ])
    .then(result => result[0].default)
    .then(i18n => importFeature()
      .then(Feature => withMergedI18n(Feature, i18n)));

  return FeaturePromise;
}
